import React from 'react';
import Header from '../components/header.component';
import { Footer } from '../components/footer.component';
import SectionHeader from '../components/common';
import { useTranslation } from 'react-i18next';
import '../scss/how-it-works.style.scss';
import HowItWorksComponent from '../components/how-it-works.component';
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from "../../common/FunctionUtils";
import SEOMetadataComponent from '../components/seo-metadata.component';
const HowItWorksPage: React.FC = () => {
    const { t, i18n } = useTranslation();

    const currentLanguage = i18n.language;

    const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
    const canonicalUrl = isEnglish
        ? `https://www.invozio.com/how-works-invozio?lang=${LOCALES.EN_US}`
        : `https://www.invozio.com/hur-fungerar-invozio?lang=${LOCALES.SV_SE}`;

    const schemaMarkup = getSchemaMarkup("hur-fungerar-invozio");
    return (
        <>
            <Header />
            <SEOMetadataComponent
                title={t('How It Works')}
                // description={t('FEATURES_MAIN_DESCRIPTION')}
                canonicalUrl={canonicalUrl}
                noindex={false}
                robots="index, follow"
                schemaMarkup={schemaMarkup}
            />
            <SectionHeader
                titleKey={t('How It Works')}
                subtitleKey={t('Welcome to Invozio, a fast-growing platform for freelancers, offering a secure and simple way to do business without starting a company.')}
                className="invozio-news-section"
                titleClassName="main-title"
                subtitleClassName="sub-title"
                alignment="center"
            />
            <HowItWorksComponent />
            <div className="bg-footer">
                <Footer />
            </div>
        </>
    );
};

export default HowItWorksPage;
